module.exports = __webpack_public_path__ + "static/img/c12.e437135.png";


//////////////////
// WEBPACK FOOTER
// ./static/hotpages/promo-vale-pedagio/c12.png
// module id = 1851
// module chunks = 1